<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <CurrentAccounts />
    </v-container>
  </div>
</template>
<script>
import CurrentAccounts from "@/components/Definiciones/CuentasCorrientes/CurrentAccounts.vue";
import LandingToolbar from "@/components/LandingToolbar/LandingToolbar.vue";

export default {
  components: { LandingToolbar, CurrentAccounts },
};
</script>
